import {Button, MenuItem} from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Ten99RouteConstants from 'Agent/1099s/Ten99RouteConstants';
import AccountRouteConstants from 'Agent/Accounts/AccountRouteConstants';
import {AgentInformationRouteConstants} from 'Agent/AgentInformation/AgentInformationRouteConstants';
import CommissionRouteConstants from 'Agent/Commissions/CommissionsRouteConstants';
import PolicyRouteConstants from 'Agent/Policies/PolicyRouteConstants';
import 'Core/components/Navigation/MyAccessMenu.sass';
import * as O from 'fp-ts/lib/Option';
import React from 'react';
import {useSelector} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {ReducerState} from 'rootReducer';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';
import RequireScope from 'Shared/components/RequireScope';
import {Scope} from 'Shared/constants/Scope';

type MyAccessMenuProps = {
  scopes: Scope[];
} & RouteComponentProps;

export const MyAccessMenu = (props: MyAccessMenuProps) => {
  const {selectedAgency} = useSelector((state: ReducerState) => state.user.profile);

  return (
    <RequireAtLeastOneScope
      scopes={[
        Scope.SearchAccounts,
        Scope.SearchPolicies,
        Scope.SearchTaxStatements,
        Scope.SearchCommissions,
        Scope.SearchClaims,
        Scope.SearchPolicyCorrespondence,
        Scope.ViewPendingUnderwritingRequirements,
        Scope.SendServiceRequest,
      ]}
    >
      <MenuStateProvider>
        {({anchor, close, open}) => (
          <>
            <Button
              id="myaccess-menu-btn"
              className="my-access-menu"
              variant="text"
              onClick={event => open(event.currentTarget)}
            >
              My Access
              <ArrowDown />
            </Button>
            <Menu
              disablePortal
              anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
              transformOrigin={{vertical: 'top', horizontal: 'center'}}
              getContentAnchorEl={null}
              onClose={close}
              open={Boolean(anchor)}
              anchorEl={anchor}
            >
              <RequireScope scopes={props.scopes} scope={Scope.SearchTaxStatements}>
                <MenuItem
                  className="my-access-menu__item"
                  id="1099-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(Ten99RouteConstants.TEN99s);
                    close();
                  }}
                >
                  1099s
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SearchAccounts}>
                <MenuItem
                  id="accounts-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(AccountRouteConstants.ACCOUNTS);
                    close();
                  }}
                >
                  Accounts
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.ViewAgentHierarchy}>
                <MenuItem
                  id="agent-hierarchy-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(AgentInformationRouteConstants.HIERARCHY);
                    close();
                  }}
                >
                  Agent Hierarchy
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.AgentLicense}>
                <MenuItem
                  id="agent-licenses-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(AgentInformationRouteConstants.AGENT_LICENSES);
                    close();
                  }}
                >
                  Agent Licenses
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SendServiceRequest}>
                <MenuItem
                  className="my-access-menu__item"
                  id="policies-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(PolicyRouteConstants.POLICY_SERVICE_REQUEST);
                    close();
                  }}
                >
                  Change Policy Service Request
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SearchCommissionSchedules}>
                <MenuItem
                  id="comission-scheduleds-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(CommissionRouteConstants.COMMISSION_SCHEDULES);
                    close();
                  }}
                >
                  Commission Schedules
                </MenuItem>
              </RequireScope>
              {O.isSome(selectedAgency) && selectedAgency.value.isNewYork && (
                <MenuItem
                  className="my-access-menu__item"
                  id="rate-generators-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(AgentInformationRouteConstants.NY_RATE_GENERATORS);
                    close();
                  }}
                >
                  Rate Generators
                </MenuItem>
              )}
              <RequireScope scopes={props.scopes} scope={Scope.SearchCommissions}>
                <MenuItem
                  className="my-access-menu__item"
                  id="comissions-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(CommissionRouteConstants.COMMISSIONS);
                    close();
                  }}
                >
                  Commissions
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SearchPolicyCorrespondence}>
                <MenuItem
                  className="my-access-menu__item"
                  id="correspondence-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(PolicyRouteConstants.CORRESPONDENCE_SUMMARIES());
                    close();
                  }}
                >
                  Correspondence
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.ViewPendingUnderwritingRequirements}>
                <MenuItem
                  id="pending-underwriting-requirements-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(PolicyRouteConstants.PENDING_UNDERWRITING_REQUIREMENT);
                    close();
                  }}
                >
                  Pending Underwriting Requirements
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SearchPolicies}>
                <MenuItem
                  className="my-access-menu__item"
                  id="policies-myaccess-menu-btn"
                  onClick={() => {
                    props.history.push(PolicyRouteConstants.POLICIES);
                    close();
                  }}
                >
                  Policies
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SearchEnrollmentApplications}>
                <MenuItem
                  id="policy-applications-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(PolicyRouteConstants.POLICY_APPLICATIONS);
                    close();
                  }}
                >
                  Policy Applications
                </MenuItem>
              </RequireScope>
              <RequireScope scopes={props.scopes} scope={Scope.SearchPolicyReports}>
                <MenuItem
                  id="policy-information-reports-myaccess-menu-btn"
                  className="my-access-menu__item"
                  onClick={() => {
                    props.history.push(AccountRouteConstants.POLICY_INFORMATION_REPORTS);
                    close();
                  }}
                >
                  Policy Information Reports
                </MenuItem>
              </RequireScope>
              {O.isSome(selectedAgency) && !selectedAgency.value.isNewYork && (
                <RequireScope scopes={props.scopes} scope={Scope.AgentResources}>
                  <MenuItem
                    id="training-site-myaccess-menu-btn"
                    className="my-access-menu__item"
                    onClick={() => {
                      window.open('http://allstatevoluntary.com/qrt/qrtrd.php');
                      close();
                    }}
                  >
                    Training Site
                  </MenuItem>
                </RequireScope>
              )}
            </Menu>
          </>
        )}
      </MenuStateProvider>
    </RequireAtLeastOneScope>
  );
};

export default MyAccessMenu;
